<template>
  <b-tag class="manifestacao-situacao-badge" :type="tipo">
    {{ rotulo }}
  </b-tag>
</template>

<script>
import {
  manifestacaoPertenceEmpresa,
  manifestacaoSituacaoLabel,
  manifestacaoSituacaoTipo,
} from '@/utils/manifestacaoSituacao';

export default {
  name: 'ManifestacaoSituacaoBadge',
  props: {
    status: {
      type: String,
      default: '',
    },
    paraLicitante: {
      type: Boolean,
      default: false,
    },
    manifestacao: {
      type: Object,
      default: null,
    },
    company: {
      type: Object,
      default: null,
    },
    fluxo: {
      type: String,
      default: '',
    },
    janelaRecursal: {
      type: String,
      default: null,
    },
    papel: {
      type: String,
      default: 'licitante',
    },
  },
  computed: {
    manifestacaoPropria() {
      return manifestacaoPertenceEmpresa(this.manifestacao, this.company);
    },
    rotulo() {
      return manifestacaoSituacaoLabel(this.status, {
        paraLicitante: this.paraLicitante,
        manifestacaoPropria: this.manifestacaoPropria,
        fluxo: this.fluxo,
        janelaRecursal: this.janelaRecursal,
        papel: this.papel,
      });
    },
    tipo() {
      return manifestacaoSituacaoTipo(this.status, {
        paraLicitante: this.paraLicitante,
        manifestacaoPropria: this.manifestacaoPropria,
        fluxo: this.fluxo,
        janelaRecursal: this.janelaRecursal,
        papel: this.papel,
      });
    },
  },
};
</script>

<style src="@/styles/manifestacao.scss" lang="scss" scoped />
